import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Divider} from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import MeasurementsForm from '../../../components/mobile/medical-history/MeasurementsForm';
import { getMedicalHistoryHealthScreeningAPICall, putMedicalHistoryHealthScreeningAPICall } from '../../../api/medical-history';

function MobileMeasurementsScreen() {
  const { t } = useTranslation(['medical-history', 'common']);
  const [dataMedicalHistory, setDataMedicalHistory] = useState({})
  const history = useHistory();

  const onBack = () => {
    history.push('/medical-history')
  }

  const fetchDataMedicalHistory = async () => {
    const { responseStatus, responseJSON } = await getMedicalHistoryHealthScreeningAPICall()
    if (responseStatus >= 200 && responseStatus < 300) {
      setDataMedicalHistory(responseJSON[0]?.data)
    } else {
      console.log(responseStatus)
    }
  }

  const onSubmit = async (data) => {
    const { responseOk } = await putMedicalHistoryHealthScreeningAPICall(data)
    if (responseOk) {
      history.push('/medical-history')
    } else {
      console.log(responseOk)
    }
  }

  useEffect(() => {
    fetchDataMedicalHistory()
  }, []);

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('medical-history:measurements.backTitle')}
        title={t('medical-history:measurements.title')}
        subtitle={t('medical-history:measurements.subtitle')}
      />
      <Divider />
      <MeasurementsForm
        dataMedicalHistory={dataMedicalHistory}
        onSubmitForm={onSubmit}
        onSubmitBtnText={t('common:button.saveUpdate')}
      />
    </>
  );
}

export default MobileMeasurementsScreen;
